import { createMessageName } from '@formkit/validation';
import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/ja.ts
var add = "追加";
var remove = "削除";
var removeAll = "全て削除";
var incomplete = "項目が正しく入力されていません。";
var submit = "送信";
var noFiles = "ファイルが選択されていません";
var moveUp = "上に移動";
var moveDown = "下へ移動";
var isLoading = "読み込み中...";
var loadMore = "さらに読み込む";
var next = "[次へ]";
var prev = "前へ";
var addAllValues = "すべての値を追加";
var addSelectedValues = "選択した値を追加";
var removeAllValues = "すべての値を削除";
var removeSelectedValues = "選択した値を削除";
var chooseDate = "日付を選択";
var changeDate = "日付を変更";
var close = "閉じる";
var open = "[開く]";
var accepted = function({
  name
}) {
  return `${name}の同意が必要です。`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)}は${date(args[0])}より後の日付である必要があります。`;
  }
  return `${sentence(name)}は将来の日付でなければなりません。`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)}には英字のみを含めることができます。`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)}には、文字と数字のみを含めることができます。`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)}には、文字とスペースのみを含めることができます。`;
};
var contains_alpha = function({
  name
}) {
  return `${sentence(name)} にはアルファベット文字が含まれている必要があります。`;
};
var contains_alphanumeric = function({
  name
}) {
  return `${sentence(name)} には文字または数字を含める必要があります。`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `${sentence(name)} には文字またはスペースを含める必要があります。`;
};
var contains_symbol = function({
  name
}) {
  return `${sentence(name)} には記号が含まれている必要があります。`;
};
var contains_uppercase = function({
  name
}) {
  return `${sentence(name)} には大文字を含める必要があります。`;
};
var contains_lowercase = function({
  name
}) {
  return `${sentence(name)} には小文字を含める必要があります。`;
};
var contains_numeric = function({
  name
}) {
  return `${sentence(name)} には数字が含まれている必要があります。`;
};
var symbol = function({
  name
}) {
  return `${sentence(name)} はシンボルでなければなりません。`;
};
var uppercase = function({
  name
}) {
  return `${sentence(name)} には大文字しか使用できません`;
};
var lowercase = function({
  name
}) {
  return `${sentence(name)} には小文字しか使用できません。`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)}は${date(args[0])}より前の日付である必要があります。`;
  }
  return `${sentence(name)}は過去の日付である必要があります。`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `このフィールドは正しく構成されていないため、送信できません。`;
  }
  const [a, b] = order(args[0], args[1]);
  return `${sentence(name)}は${a}と${b}の間にある必要があります。`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)}が一致しません。`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)}は有効な日付ではありません。${args[0]}の形式を使用してください。`;
  }
  return "このフィールドは正しく構成されておらず、送信できません。";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)}は${date(args[0])}と${date(args[1])}の間にある必要があります。`;
};
var email = "有効なメールアドレスを入力してください。";
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)}は${list(args)}で終わっていません。`;
};
var is = function({
  name
}) {
  return `${sentence(name)}は許可された値ではありません。`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)}は少なくとも1文字である必要があります。`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)}は${max2}文字以下である必要があります。`;
  }
  if (min2 === max2) {
    return `${sentence(name)} の長さは ${max2} 文字でなければなりません。`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)}は${min2}文字以上である必要があります。`;
  }
  return `${sentence(name)}は${min2}から${max2}文字の間でなければなりません。`;
};
var matches = function({
  name
}) {
  return `${sentence(name)}は許可された値ではありません。`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `${name}は${args[0]}を超えることはできません。`;
  }
  return `${sentence(name)}は${args[0]}以下である必要があります。`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "ファイル形式は許可されていません。";
  }
  return `${sentence(name)}は${args[0]}である必要があります。`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `${name}は${args[0]}未満にすることはできません。`;
  }
  return `${sentence(name)}は少なくとも${args[0]}である必要があります。`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `“${value}”は許可された${name}ではありません。`;
};
var number = function({
  name
}) {
  return `${sentence(name)}は数値でなければなりません。`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join("または")}${labels}が必要です。`;
};
var required = function({
  name
}) {
  return `${sentence(name)}は必須です。`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)}は${list(args)}で始まっていません。`;
};
var url = function() {
  return `有効な URL を入力してください。`;
};
var invalidDate = "選択した日付は無効です。";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var ja_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, ja_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=ja.mjs.map